/*jslint regexp: true, evil: true */
define(['c21', 'c21/Params', 'jquery', 'jquerybbq', 'c21/track', 'usagetrack'], function (c21, Params, $, jquerybbq, track, usagetrack) {
   "use strict";

   var m_aLastRequestTime,
      m_strLastRequestedHash,
      m_oCachedRequests = {},

      m_oViewEngineUrls = {
         //localArea: "/localArea.c21",
         //school: "/school.c21",
         pdpViewEngine: "/property.c21"
      },

      m_bChangingPage = false,
      m_bSettingHash = false,

      m_bIgnoreNextPopstate = false;

   /**
    * Set the hash to the specified value
    * @param strHash  the value to set the hash to
    * @param bOverwrite
    * @param oHashModifications
    */
   function setHash (strHash, bOverwrite, oHashModifications) {
      var oParams, oHashParams = {};

      oParams = new Params(true).getParams();

      if (strHash || strHash === "") {
         oHashParams = c21.queryToJSON(strHash);
         if (oHashModifications) {
            $.each(oHashModifications, function (key, value) {
               if (value === null) {
                  delete oHashParams[key];
               } else {
                  oHashParams[key] = value;
               }
            });
         }

         $.each(oHashParams, function (key, value) {
            var paramVal = oParams[key];
            oParams[key] = value;

            if (paramVal === null) return;
            if (paramVal === undefined) return;

            // Remove any hash param that has already been set in url param
            // EX: ?lid=CNYBROOKLYN#lid=CNYBROOKLYN would now just be ?lid=CNYBROOKLYN
            if (paramVal.toString() === value.toString()) {
               delete oHashParams[key];
            }
         });
      }

      if (bOverwrite) {
         m_strLastRequestedHash = $.param(oParams);
      }

      if (areHashParamsDifferent(oParams)) {
         m_bIgnoreNextPopstate = true;
         m_bSettingHash = true;

         document.location.hash = $.param(oHashParams);

         // The hash change is performed ASYNCHRONOUSLY
         // (I really don't understand why)
         setTimeout(function () {
            m_bSettingHash = false;
         }, 1);
      }
   }

   function areHashParamsDifferent (oParams) {
      var bHashIsTheSame;

      if (!oParams) oParams = new Params(true).getParams();

      var o1 = $.extend({}, oParams);
      var o2 = $.extend({}, new Params().getParams());

      // CEN-1442 Fixed issue where server was not sending filters correctly
      // (server added caching to url)
      delete o1.reqts;
      delete o1.reqid;
      delete o2.reqts;
      delete o2.reqid;

      var aHashParams = objectToArray(o1);
      var aCurrentParams = objectToArray(o2);

      sortOrderedKeyValueSet(aHashParams);
      sortOrderedKeyValueSet(aCurrentParams);

      var strHashParams = $.param(aHashParams);
      var strCurrentParams = $.param(aCurrentParams);

      bHashIsTheSame = (strHashParams === strCurrentParams);

      return !bHashIsTheSame;
   }

   function sortOrderedKeyValueSet (a) {
      a.sort(function (a, b) {
         if (a.name > b.name) {
            return 1;
         }

         if (a.name < b.name) {
            return -1;
         }

         return 0;
      });
   }

   function objectToArray (o) {
      var a = [];
      $.each(o, function (key, value) {
         a.push({
            name: key,
            value: value
         });
      });
      return a;
   }

   /**
    * Get the current hash value
    * Example: http://example.com#myhash Returns: "myhash"
    * @return {String}
    */
   function getHash () {
      return $.param.fragment();
   }

   /**
    * Fired when the hash changes
    * @param event
    * @param ignoreEmpty  whether to ignore empty hashes
    */
   function onHashChange () {
      var strHash;

      strHash = $.param(getParameters());

      // Don't load the same hash twice
      if (m_strLastRequestedHash === strHash) {
         return;
      }

      m_strLastRequestedHash = strHash;

      /*
      strRelativePath = document.location.pathname.substring(1);
      if (window.viewEngineName === "suggest") {
         c21.search.handleHash(c21.queryToJSON(strHash));
      } else if (window.viewEngineName === "search") {
         maps.handleHash(c21.queryToJSON(strHash));
      } else if (window.viewEngineName === "search") {
         portalResults.handleHash(c21.queryToJSON(strHash));
      } else if (window.viewEngineName === "school") {
         SchoolDetails.handleHash(c21.queryToJSON(strHash));
      }*/
   }

   /**
    * Read the response data from a request and act appropriately
    * @param data
    */
   function interpretResponseData (data, aHashModifications) {
      let replacedBodyMain = false;
      $.each(data, function (index, instruction) {
         var jElement, strAction = instruction.action;
         switch (strAction) {
            case 'htmlReplace':
               jElement = $("#" + instruction.tag);

               // Use triggerHandler() instead of trigger(), otherwise bubbling will occur
               jElement.triggerHandler("beforePortalAjaxLoad");

               try {
                  jElement.html(instruction.html);
               } catch (e) {
                  if (window.console && console.error) {
                     console.error(e);
                  }
               }

               // Use triggerHandler() instead of trigger(), otherwise bubbling will occur
               jElement.triggerHandler("portalAjaxLoadEvent");

               if (instruction.tag === 'bodyMain') {
                  replacedBodyMain = true;
               }

               break;

            case 'execute':
               try {
                  eval(instruction.code);
               } catch (e) {
                  c21.handleErrors(["Sorry, an unhandled error has occured."]);
                  //alert(e.description + "\n\n" + instruction.code);
               }
               break;

            case 'setSeoMeta':
               document.title = instruction.title;
               $("meta[name='description']").attr("content", instruction.description);
               $("meta[name='keywords']").attr("content", instruction.keywords);
               break;

            case 'setUrl':
               replaceUrl(instruction.url);
               break;

            case 'setSpanishUrl':
               replaceUrl(instruction.englishCanonical ? instruction.englishUrl : instruction.spanishUrl);
               $("#header-language-url-spanish").attr('href', instruction.spanishUrl);
               $("#header-language-url-english").attr('href', instruction.englishUrl);
               break;

            case 'redirect':
               gotoPageUrl(instruction.url);
               break;

            case 'error':
               // This is handled by PageForm
               break;

            case 'setBodyIdAndClasses':
               $(document.body).attr({
                  id: instruction.bodyId,

                  // Clear the previous class names
                  'class': ''
               })
                  // Add the the body id as a class name
                  .addClass(instruction.bodyId)

                  // Add additional class names.
                  // We use addClass so if there are duplicate
                  // class names, they will be consolidated.
                  .addClass(instruction.bodyClasses);
               break;

            default:
               //alert("Error: Unknown Instruction [" + instruction.type + "]");
         }
      });

      // Process usage and click-to-call tracking after the main page body has been replaced
      if (replacedBodyMain) {
         $(document).ready(function () {
            window.usagetrack.reset();
            $(window).click(window.usagetrack.onClick);
            window.usagetrack.process('view', document);
            window.ctctrack.process();
         });
      }

      ajaxifyLinks();
   }

   function responseToJson (tResponse) {
      var oData = tResponse;

      if (typeof tResponse !== "object") { // if it is an object, JSON is already parsed by jquery because of content type
         oData = $.parseJSON(tResponse); // otherwise assume we got JSON without correct content type
      }

      return oData;
   }

   /**
    * Called on an AJAX response
    * @param response
    * @param textStatus
    * @param XMLHttpRequest
    */
   function viewEngineAjaxResponse (response, textStatus, XMLHttpRequest, fnCallback) {
      // NOTE: This method is called with a custom "this" object
      /*jshint validthis: true */

      var data;

      // Disable the loading indicator
      if (this.loadingIndicator) {
         this.loadingIndicator.destroy();
      }

      // Disregard old requests in the same sub view
      if (this.requestTime < m_aLastRequestTime[this.subView]) {
         return;
      }

      data = responseToJson(response);

      // Only update the hash if it's requested
      var aHashModifications = {};
      interpretResponseData(data, aHashModifications);

      if (fnCallback) {
         fnCallback();
      }

      if (c21.objectHasChildren(aHashModifications)) {
         return setHash(this.query, true, aHashModifications);
      }

      if (this.updateHash) {
         setHash(this.query);
      }
   }

   function fetch (o) {
      if (o.cache) {
         var result = m_oCachedRequests[o.url];
         if (result) {
            if (o.success) {
               o.success.call(o.context, result);
            }

            if (o.loadingIndicator) {
               o.loadingIndicator.destroy();
            }
         } else {
            var fnOldSuccess = o.success;
            o.success = function (data, textStatus, jqXHR) {
               m_oCachedRequests[o.url] = data;
               fnOldSuccess.apply(this, arguments);
            };
            $.ajax(o);
         }
      } else {
         $.ajax(o);
      }
   }

   function disableAjaxAndGotoLink (url, jAnchor) {
      if (jAnchor && jAnchor.length > 0) {
         jAnchor.addClass('noFragment').click();
      } else {
         window.location.href = url;
      }
   }

   /**
    * Remove all jQuery-bound events on the object that do not have a .persist namespace
    */
   function removeNonPersistEvents (jEl) {
      var eventTypes = $._data(jEl[0], "events");

      if (!eventTypes) return;

      $.each(eventTypes, function (strName, aEvents) {
         // Need to clone the array so looping doesn't fail
         // as we delete items from it
         var aEventsClone = aEvents.slice();

         $.each(aEventsClone, function (i, oData) {
            var aNamespaces = oData.namespace.split(".");
            if ($.inArray("persist", aNamespaces) === -1) {
               // Useful for figuring out libs that need to persist
               // Just look at the handler property
               //console.debug(oData);

               jEl.off(oData.type, oData.handler);
            }
         });
      });
   }

   function removeEventsPageChange () {
      removeNonPersistEvents($(window));
      removeNonPersistEvents($(document.body));
      removeNonPersistEvents($("#bodyMain"));
   }

   function loadPage (url, jAnchor) {
      if (m_bChangingPage) return;

      var oData = {
         subView: 'fragment'
      };

      if ($("#preview-widget").length) {
         // Cache breaker for preview
         oData.__x = Math.random();
      }

      $("#bodyMain").html('<div class="ajax-load"></div>');
      window.abstractEventBehavior.reset();

      // Pages will often bind to .resize and whatnot
      // but we really ought to clear all these events
      // There are some exceptions. For those, use the
      // .persist jQuery namespace
      removeEventsPageChange();

      m_bChangingPage = true;

      // Scroll to the top of the page
      $("html, body").animate({
         scrollTop: 0
      }, {
         duration: 0
      });

      $("link[rel=canonical]").attr("href", window.location.origin + url);

      $.ajax({
         url: url,
         data: oData,
         success (data, textStatus, request) {
            var strHeader = request.getResponseHeader('Content-Type');
            m_bChangingPage = false;

            // If these are a set of instructions
            if (strHeader.indexOf('application/json') >= 0) {
               interpretResponseData(data);

            // If this is a text/html fragment
            // (expect to have inline script tags for changing title)
            } else if (strHeader.indexOf('text/html') >= 0) {
               if (strHeader.indexOf('doctype')) {
                  disableAjaxAndGotoLink(url, jAnchor);
               } else {
                  interpretResponseData({
                     action: 'htmlReplace',
                     tag: 'bodyMain',
                     html: data
                  });
               }
            } else {
               disableAjaxAndGotoLink(url, jAnchor);
            }
         }
      });
   }

   function replaceUrl (strHref) {
      var strHash = getHash();

      if (strHash) {
         strHref += "#" + strHash;
      }

      // Keep the link in the browser history
      try {
         history.replaceState(null, null, strHref);
      } catch(error) {
         console.error(error);
      }

      track.doPageTrack(); // 'I think I should track the URL ' + window.location.href);
      $(window).trigger('replacestate');
   }

   function pushState (strHref) {
      // Keep the link in the browser history
      history.pushState(null, null, strHref);
      $(window).trigger('pushstate');
   }

   function gotoPageUrl (strHref, jAnchor) {
      if (m_bChangingPage) return;

      pushState(strHref);
      loadPage(strHref, jAnchor);
   }

   function ajaxifyLinks () {
      $(document).off('click.ajaxify', 'a').on('click.ajaxify', 'a', function (e) {
         // Allow user to open links in a new tab via CMD+Click (Mac) or CTRL+Click (Windows)
         if (e.metaKey || (navigator.platform.toUpperCase().indexOf('WIN')!==-1 && e.ctrlKey)) { 
            return;
         }

         // Ignore if browser does not support the HTML5 history API
         if (!(window.history && window.history.pushState)) {
            return;
         }

         var jAnchor = $(this),
            strHref,
            strHash,
            strExtension;

         // Ignore if the link does something else
         if (jAnchor.hasClass('noFragment')) {
            return;
         }

         // Ignore if the href is empty
         strHref = jAnchor.attr('href');
         if (!strHref) {
            return;
         }

         // Ignore if it's a telephone link
         if (strHref.indexOf("tel:") === 0) {
            return;
         }

         // Ignore if the href is javascript
         /*jslint scripturl: true */
         if (strHref.indexOf("javascript:") === 0) {
            return;
         }

         // Ignore if the href contains a hash
         if (strHref.indexOf('#') === 0) {
            if (!jAnchor.data("ignoreHash")) {
               pushState(strHref);
               strHash = strHref.split("#")[1];
               hashScroll(strHash);
               e.preventDefault();
            }
            return;
         }

         // Ignore if the href is absolute
         if (strHref.indexOf('http') === 0) {
            return;
         }

         // Ignore if this is an image or whatever
         strExtension = strHref.split('.').pop();
         switch (strExtension) {
            case 'jpg':
            case 'jpeg':
            case 'png':
            case 'bmp':
            case 'doc':
            case 'pdf':
               return;
         }

         // here can cause data loading, etc.
         gotoPageUrl(strHref, jAnchor);

         // Do not give a default action
         e.preventDefault();
      });
   }

   function getHref () {
      // == Example ==
      // Location: http://test.site.lbradley.century21.com/real-estate/brooklyn-ny/LCNYBROOKLYN/#foo
      // Output: /real-estate/brooklyn-ny/LCNYBROOKLYN/#foo
      return '/' + location.href.split('/').splice(3).join('/');
   }

   /**
    * Attempt to animate scroll to an element with the given hash
    * If the element doesn't exist or the hash is not an element selector,
    * exit safely.
    * @param strHash
    */
   function hashScroll (strHash) {
      var jEl;

      if (!strHash) return;

      try {
         jEl = $("#" + strHash);
      } catch (e) {
         // Not a valid selector
         // EX: #t=0&c=23
         return;
      }

      $("html, body").animate({
         scrollTop: jEl.offset().top
      }, {
         duration: 300
      });
   }

   // CEN-2093 Tracking for homesforsale.century21.com domain
   function specialTracking () {
      $(document).off('mousedown.specialTrack', 'a').on('mousedown.specialTrack', 'a', function (e) {
         var elAnchor = this; // For AF ;)
         if ((elAnchor.protocol === 'http:' || elAnchor.protocol === 'https:') && elAnchor.hostname.indexOf('homesforsale.century21.com') === 0) {
            track.doEvent('Offsite',  'Zap Link', window.location.href);
         }
      });
   }

   function initialize () {
      m_aLastRequestTime = {};
      //$(window).bind("hashchange.persist", onHashChange);
      ajaxifyLinks();
      specialTracking();

      var strLastHref = getHref(),
         strLastHash = getHash();

      function handled (strHref, strHash) {
         strLastHref = strHref;
         strLastHash = strHash;
         m_bIgnoreNextPopstate = false;
      }

      $(window).on({
         'pushstate.persist.ajaxify': function () {
            strLastHref = getHref().split("#")[0];
            strLastHash = getHash();
         },

         'popstate.persist.ajaxify': function () {
            var strHref = getHref().split("#")[0],
               strHash = getHash();

            // This request has already been handled
            if (m_bIgnoreNextPopstate) {
               handled(strHref, strHash);

            // The HREF is the same, but maybe not the hash?
            // Well, fragments don't get fetched on hash change!
            } else if (strLastHref === strHref) {
               // Browser will handle scrollpoints for us :)
               // No need to animate when navigating history
               //if (strLastHash !== strHash) {
               //   hashScroll(strHash);
               //}
               handled(strHref, strHash);

            // Good old-fashioned fragment request
            } else {
               handled(strHref, strHash);
               loadPage(strHref);
            }
         },

         'hashchange.persist.ajaxify': function () {
            if (!m_bSettingHash) {
               // Event that triggers when the hash changes,
               // but NOT due to setHash being called
               $(window).trigger("hashchangenotset");
            }
         }
      });
   }

   /**
    * Do an SEO-friendly AJAX call
    * 
    * @param strSubView  the sub view associated with the request (ex: searchView.AllSubView)
    * @param strPath     the url to call
    * @param strQuery    the query options
    * @param options     additional options
    */
   function doViewEngineAjax (strSubView, strPath, strQuery, options) {
      var iRequestTime, strRequestUrl, strLang,
         o = options || {}, fnCallback;

      iRequestTime = (new Date()).getTime();
      m_strLastRequestedHash = strQuery;
      m_aLastRequestTime[strSubView] = iRequestTime;

      var context = {
         loadingIndicator: o.loadingIndicator,
         subView: strSubView,
         query: strQuery,
         updateHash: o.updateHash,
         requestTime: iRequestTime
      };

      if (o.callback) {
         fnCallback = function (response, textStatus, XMLHttpRequest) {
            viewEngineAjaxResponse.call(this, response, textStatus, XMLHttpRequest, function () {
               options.callback(response, textStatus, XMLHttpRequest);
            });
         };
      } else {
         fnCallback = viewEngineAjaxResponse;
      }

      strLang = "";
      strRequestUrl = [strLang, strPath, "?", strQuery, (strQuery) ? "&" : "", "subView=", strSubView].join("");

      fetch({
         cache: o.cache,
         url: strRequestUrl,
         success: fnCallback,
         context: context
      });
   }

   /**
    * Get all the parameters from the query string and hash as an object
    * Example: http://example.com/?banana=yellow#apple=red
    * Returns: { banana : "yellow", apple : "red" }
    * 
    * @return {Object}
    */
   function getParameters () {
      return new Params().getParams();
   }

   initialize();

   return {
      responseToJson: responseToJson,
      getParameters: getParameters,
      setHash: setHash,
      getHash: getHash,

      /**
       * Bind an AJAX load event to an element
       * @param {jQuery} jElement the jQuery element to bind to
       * @param {function} fn the function to bind
       */
      bindLoadEvent: function (jElement, fn) {
         jElement.bind("portalAjaxLoadEvent", fn);

         // If the element exists
         if (jElement.size() > 0) {
            // Call the event immediately
            fn();
         }
      },

      /**
       * Allow a function to be run in the same DOMAIN as this frame
       * See: /myc21/iframe.proxy.html
       * @param {function} fn the function to call
       */
      callThisFrame: function (fn) {
         setTimeout(fn, 1);
      },

      /**
       * Shorthand for doViewEngineAjax
       * @param o {object} the options
       * @config {string} subView (ex: "FindAHomeSuggestLocation")
       * @config {string} url (ex: "/findahome.c21")
       * @config {string} [query] (ex: "t=1&lid=CAZPHOENIX")
       * @config {boolean} [cache] whether to aggressively cache the results
       * @config {function} [complete] function to call when the request is complete
       * @config {c21.LoadingIndicator} [loadingIndicator]
       */
      fetchView: function (o) {
         var strUrl = o.url || m_oViewEngineUrls[window.viewEngineName] || "/search.c21";
         doViewEngineAjax(o.subView, strUrl, o.query, o);
      },

      // For legacy purposes
      doViewEngineAjax: doViewEngineAjax,

      /**
       * C21 implementation of $.ajax
       * @param o
       * @config {string} url
       * @config {boolean} [cache]
       * @config {function} [success]
       * @config {object} [context]
       */
      fetch: fetch,

      /**
       * Send a report to the specified URL
       * @param {object} options
       * @config {string} url
       * @config {string} data
       */
      report: options => {
         var strRndId = (Math.random() * 10000000000000).toString(),
            strRequestUrl = [options.url, "?", options.data, "&rnd=", strRndId].join("");

         $.get(strRequestUrl);
      },

      /**
       * Show the portalAjax debug console
       */
      startDebug: function () {
         $.getScript("/js/src/c21/ajax.debug.js", function () {
            window.ns.start();
            c21.ajax.debug.initialize();
         });
      },

      doHashTest: function () {
         if (getHash()) {
            onHashChange();
         }
      },

      /**
       * Whether the AJAX hash is the same as the params
       */
      areHashParamsDifferent: areHashParamsDifferent,

      gotoPageUrl: gotoPageUrl
   };
});
